// extracted by mini-css-extract-plugin
export default {"container":"src-pages-ProductReview-ProductReviewDetail-Query-css-module__container--DP-bc"};